<template>
    <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
        <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="row align-items-center">
                <div id="errorNotification" class="col-md-12">
                    <base-alert v-if="errorMessage != null" type="danger">
                        <span class="alert-inner--text"> {{ errorMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                    <base-alert v-if="successMessage != null" type="success">
                        <span class="alert-inner--text"> {{ successMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                </div>
                <div class="col-md-5">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                        {{ displayProfile }}
                    </h3>
                    <p class="sub-label">{{ profileSubLabel }}</p>
                </div>
                <div class="col-md-7 text-right">
                    <base-dropdown class="nav-link pr-0 float-right" position="right">
                        <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                        </div>
                        <template>
                            <div class="dropdown-header noti-title">
                                <h6 class="text-overflow m-0">ACTIONS</h6>
                            </div>
                            <div v-if="accessRights.includes('T')"
                                class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                                <i class="fa fa-print"></i>
                                <span>Print</span>
                            </div>
                            <div v-if="serverType == 'ho' && accessRights.includes('I')" class="dropdown-item"
                                @click.prevent="showActionDrawer('import_list')">
                                <i class="fa fa-upload"></i>
                                <span>Import</span>
                            </div>
                            <div class="dropdown-item" @click.prevent="showActionDrawer('export_list')">
                                <i class="fa fa-download"></i>
                                <span>Export</span>
                            </div>
                            <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                                <i class="fa fa-list-ul"></i>
                                <span>Customize List</span>
                            </div>
                        </template>
                    </base-dropdown>
                    <div v-if="serverType == 'ho'">
                        <div v-if="checkedItems.length == 0 && accessRights.includes('A')">
                            <base-button class="float-right ml-1" type="primary" size="sm"
                                @click.prevent="showDrawer(0)">+ Add
                                New {{ _.startCase(_.singularize(currentProfile)) }}</base-button>
                        </div>

                        <div v-else-if="checkedItems.length > 0 && accessRights.includes('W')">
                            <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default"
                                size="sm" @click.prevent="massupdate('status', 'A')">Activate</base-button>
                            <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default"
                                size="sm" @click.prevent="massupdate('status', 'I')">Deactivate</base-button>
                            <div class="ml-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="profileAction == 'customize_list'">
                <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
                <small>Check the fields that you want to see on the list. Drag the fields to
                    specify position.</small>
                <br /><br />

                <div class="list-group list-group-item">
                    <div class="row">
                        <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
                        <div class="col-md-6">
                            <a-checkbox class="float-right" @change="onCheckAllField" :checked="this.checkedFields.length == this.availableFields.length
                                " />
                        </div>
                    </div>
                </div>

                <draggable :key="draggableKey" :list="availableFields" class="list-group" @start="dragging = true"
                    @end="dragging = false">
                    <div class="list-group-item draggable"
                        :style="index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''"
                        v-for="(element, index) in availableFields" :key="element">
                        <div class="row">
                            <!-- This _.startCase() will convert any casing into Start Case -->
                            <div class="col-md-6">
                                {{ _.startCase(element) }}
                            </div>
                            <div class="col-md-6">
                                <a-checkbox class="float-right" @change="onCheckField(element)"
                                    :checked="checkedFields.includes(element)" />
                            </div>
                        </div>
                    </div>
                </draggable>

                <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
                    <button class="btn btn-primary float-right" @click.prevent="updateTableList">
                        Update List
                    </button>
                </div>
            </div>

            <div v-if="profileAction == 'export_list'">
                <h6 class="heading-small text-muted mb-4">Export Options</h6>

                <base-alert v-if="errors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <ul>
                        <li v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </base-alert>

                <div>
                    <a-radio-group v-model="exportSelection">
                        <a-radio :style="radioStyle" :value="0">Export All</a-radio>
                        <a-radio :style="radioStyle" :value="1">Export Current Page</a-radio>
                        <a-radio :style="radioStyle" :value="2">Export Selected</a-radio>
                        <a-radio :style="radioStyle"
                            :value="3">
                            Export Filtered</a-radio>
                    </a-radio-group>
                </div>

                <div
                    style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
                </div>
            </div>

            <div v-if="profileAction == 'print_list'">
                <h6 class="heading-small text-muted mb-4">Print Options</h6>
            </div>

            <div v-if="profileAction == 'import_list'">
                <import-profile @closeDrawer="closeDrawer"></import-profile>
            </div>
        </a-drawer>

        <a-drawer title="" :width="currentProfile !== 'supercard_promos' ? 600 : 1000" placement="right" @close="onClose" :visible="visible">
            <div>
                <supercard-type-form v-if="currentProfile == 'supercard_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></supercard-type-form>
                <supercard-promo-form v-if="currentProfile == 'supercard_promos'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></supercard-promo-form>
                <supercard-purchase-type-form v-if="currentProfile == 'supercard_purchase_types'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></supercard-purchase-type-form>
                <supercard-format-form v-if="currentProfile == 'supercard_formats'" @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey" :viewMode="viewMode"></supercard-format-form>
            </div>
        </a-drawer>

        <div class="table-responsive">
            <!-- {{this.accessRights}} -->
            <a-spin :spinning="loading">
                <vuetable ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields"
                    :sort-order="sortOrder" :show-sort-icons="true" :per-page="10" :css="css.table"
                    no-data-template="Empty" pagination-path="" data-path="data" @vuetable:checkbox-toggled-all="log"
                    @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError"
                    @vuetable:pagination-data="onPaginationData">
                    <template slot="actions" slot-scope="props">
                        <div v-if="serverType == 'ho'" class="table-button-container">
                            <button v-if="accessRights.includes('V')"
                                class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)"
                                id="view">View</button>
                            <button v-if="accessRights.includes('W')"
                                class="btn btn-warning btn-sm"
                                @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                            <a-popconfirm v-if="accessRights.includes('D')" title="You are about to delete this record?"
                                @confirm="deleteRow(props.rowData.id)" okText="Delete" cancelText="Cancel">
                                <a class="btn btn-danger btn-sm text-white">Delete</a>
                            </a-popconfirm>
                        </div>
                        <div v-else class="table-button-container">
                            <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm" @click.prevent="showDrawer(props.rowData.id)" id="view">View</button>&nbsp;&nbsp;
                        </div>
                    </template>
                </vuetable>
            </a-spin>
        </div>

        <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent' : ''">
            <div class="pagination ui basic segment grid">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"
                    :css="css.pagination">
                </vuetable-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import SupercardPromoForm from "../Supercard Profiles/SupercardPromoForm.vue";
import SupercardTypeForm from "../Supercard Profiles/SupercardTypeForm.vue";
import SupercardPurchaseTypeForm from "../Supercard Profiles/SupercardPurchaseTypeForm.vue";
import SupercardFormatForm from "../Supercard Profiles/SupercardFormatForm.vue";

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";
import draggable from "vuedraggable";

import { formatStatus } from "../../utilities.js"

import ImportProfile from '../ImportProfile';
var component_x;

import moment from "moment";

export default {
    name: "profiles-table",
    props: {
        type: {
            type: String
        },
        title: String
    },
    components: {
        Vuetable,
        VuetablePagination,
        SupercardPromoForm,
        SupercardTypeForm,
        SupercardPurchaseTypeForm,
        SupercardFormatForm,
        ImportProfile,
        draggable
    },
    computed: {
        ...mapState([
            "currentProfile",
            "currentApiURL",
            "endPoint",
            "profileId",
            "parameters",
            "serverType",
        ]),
        displayProfile() {
          const profileMap = {
            supercard_promos: "Supercard Item Promos"
          }

          return profileMap[this.currentProfile] || _.startCase(this.currentProfile)
        },
    },
    data() {
        return {
            initLoad: 0,
            loading: false,
            locationOptions: [],
            viewMode: false,
            accessRights: [],
            errors: [],
            filterStatus: "",
            exportSelection: 0,
            profileAction: "",
            checkedFields: [],
            checkedItems: [],
            availableFields: [],
            errorMessage: null,
            successMessage: null,
            componentKey: 0,
            modalKey: 0,
            drawerVisible: false,
            visible: false,
            apiURL: "",
            // fields: ['__checkbox', "id", "code", "name", "status", '__slot:actions'],
            fields: [
                "__checkbox",
                { name: "id", title: "id" },
                { name: "code", title: "code" },
                { name: "name", title: "name" },
                { name: "status", title: "status" },
                "__slot:actions"
            ],
            sortOrder: [
                {
                    field: "name",
                    direction: "asc",
                },
            ],
            httpOptions: {
                headers: {
                    Authorization: "Bearer " + secureStorage.getItem("accessToken"), 'Request-Source': "BXI-Web"
                },
            },
            css: {
                table: {
                    tableClass:
                        "table table-sm table-striped table-bordered table-hovered",
                    loadingClass: "loading",
                },
                pagination: {
                    infoClass: "pull-right",
                    wrapperClass: "vuetable-pagination pull-right",
                    activeClass: "btn-primary btn-sm",
                    disabledClass: "disabled",
                    pageClass: "btn btn-border",
                    linkClass: "btn btn-border",
                    icons: {
                        first: "",
                        prev: "",
                        next: "",
                        last: "",
                    },
                },
            },
            radioStyle: {
                display: "block",
                height: "30px",
                lineHeight: "30px",
            },
            draggableKey: 0,
            profileSubLabel: ""
        };
    },
    watch: {
        currentApiURL: function () {
            this.$refs.vuetable.resetData();
            this.apiURL = this.currentApiURL;
        },
        parameters: function () {
            this.apiURL = this.currentApiURL
            this.apiURL = this.apiURL + this.parameters
            this.$refs.vuetable.selectedTo = []
            this.checkedItems = []
        },
        currentProfile: function () {
            this.initializeTable()
        },
        checkedFields: function () {
            if (!this.checkedFields.length) {
                this.$notification['warning']({
                    message: 'Customized columns cannot be empty',
                    description: 'Columns reset to default.',
                    placement: 'bottomRight'
                })

                this.checkedFields = ["id", "code", "name", "status"]
                this.fields = ["__checkbox", { "name": "id", "title": "id" }, { "name": "code", "title": "code" }, { "name": "name", "title": "name" }, { name: "status", callback: (value) => formatStatus(value) }, "__slot:actions"]
                
            }
        },
    },
    methods: {
        ...mapActions(["updateProfileId"]),
        closeDrawer() {
            this.onClose();
        },
        refreshPage() {
            this.onClose();
            this.$refs.vuetable.refresh();
            this.successMessage = "Successful Operation";
            this.errorMessage = null;
        },
        showModal(id) {
            if (event.target.id == "view") {
                this.viewMode = true;
            } else {
                this.viewMode = false;
            }
            this.modalKey++;
            this.updateProfileId(id);
        },
        showDrawer(id) {
            if (event.target.id == "view") {
                this.viewMode = true;
            } else {
                this.viewMode = false;
            }
            this.componentKey++;
            this.updateProfileId(id);
            this.visible = true;
        },
        async showActionDrawer(action) {
            if (action == "customize_list") {
                var response = await HTTPRequest.getRequest(
                    this.endPoint + this.currentProfile + "/get_viewable_fields",
                    null
                );

                let unsortedFields = response["fields"];
                let sortedFields = this.checkedFields.slice();

                unsortedFields.forEach(fieldName => {
                    if (!this.checkedFields.includes(fieldName))
                        sortedFields.push(fieldName)
                });

                this.availableFields = sortedFields;

            }
            this.profileAction = action;
            this.drawerVisible = true;
        },
        onClose() {
            this.errors = [];
            this.drawerVisible = false;
            this.visible = false;
            this.componentKey++;
        },
        log() {
            this.checkedItems = this.$refs.vuetable.selectedTo;
        },
        onCheckField(fieldName) {
            if (this.checkedFields.includes(fieldName)) {
                var indexValue = this.fields.findIndex(object => {
                    return object.name == fieldName;
                });
                if (indexValue > -1) this.fields.splice(indexValue, 1)
                var indexValue2 = this.checkedFields.indexOf(fieldName)
                if (indexValue2 > -1) this.checkedFields.splice(indexValue2, 1)
                console.log("delete")
            } else {
                let filterColumn = ""
                filterColumn = fieldName.replace(/_/g, " ")
                
                if (!this.fields.includes(fieldName)) {
                    this.fields.pop()
                    this.fields.push({ name: fieldName, title: filterColumn })
                    this.fields.push("__slot:actions")
                }
                console.log("add")
                this.checkedFields.push(fieldName)
            }

            let storeName = this.currentProfile + "SupercardProfileCheckedFields"
            localStorage.setItem(storeName, JSON.stringify(this.checkedFields))
            this.reinitializeFields()
        },
        onCheckAllField() {
            if (this.checkedFields.length == this.availableFields.length) {
                console.log("Empty")
                this.checkedFields = []
                // this.fields = [
                //                 "__checkbox",
                //                 {name: "id", title: "id"},
                //                 {name: "name", title: "name"},
                //                 "__slot:actions"
                //               ]
            } else {
                console.log("Copy")
                let insertField = []
                this.checkedFields = this.availableFields.slice()
                this.fields = ['__checkbox']
                this.checkedFields.forEach((c) => {
                    let filterColumn = ""
                    filterColumn = c.replace(/_/g, " ")
                
                    this.fields.push({ name: c, title: filterColumn })
                })
                this.fields.push("__slot:actions")
            }
            // console.log(this.fields)
            let storeName = this.currentProfile + "SupercardProfileCheckedFields"
            localStorage.setItem(storeName, JSON.stringify(this.checkedFields))
            this.reinitializeFields()
        },
        reinitializeFields() {
            this.$nextTick(() => {
                this.$refs.vuetable.normalizeFields();
            });
        },
        async massupdate(field_name, value) {
            var field_update = {};
            field_update[field_name] = value;
            var payload = { ids: this.checkedItems, field_update: field_update };
            var response = await HTTPRequest.postRequest(
                this.endPoint + this.currentProfile + "/mass_update",
                null,
                payload
            );
            console.log(this.$refs.vuetable.selectedTo);
            if (response["message"] == "OK") {
                this.successMessage = "Update successful!";
                this.$refs.vuetable.refresh();
                this.checkedItems = [];
                this.$refs.vuetable.selectedTo = [];
            } else {
                this.successMessage = "Update failed!";
                // alert("Error processing")
            }
        },
        async onPaginationData(paginationData) {
            // await axios({
            //   method: 'PUT',
            //   url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
            //   headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            // })
            this.$refs.pagination.setPaginationData(paginationData);
        },
        async onLoadError(error) {
            // request for new token or reauthenticate
            if (error.response.status == 401) {
                var auth_response = await HTTPRequest.authenticate(
                    component_x.endPoint
                );
                if (auth_response["status"] == "Ok") {
                    this.$router.go();
                } else {
                    alert("Cannot get access token. Please login again.");
                    this.$router.push("/");
                }
            } else {
                if (error.response.data.error == "Session expired") {
                    alert("Session is already expired. Please login again.");
                    document.getElementById("logoutButton").click();
                }
            }
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        deleteRow(id) {
            axios({
                method: "delete",
                url: this.endPoint + this.currentProfile + "/" + id,
                headers: {
                    Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                    "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-Web"
                },
            })
                .then(function () {
                    component_x.successMessage = "Successfully deleted record";
                    component_x.$refs.vuetable.refresh();
                })
                .catch(function (error) {
                    // alert(
                    //     error.response.data.error
                    // );
                    component_x.displayMessage(error.response.data);
                });
        },
        download() {
            // Must update other Profile Tables download function to be aligned
            var payload = {};
            var additional_parameters = "";
            var baseUrl = this.currentApiURL + "/download?file_type=csv";
            if (this.exportSelection == "0") {
                // All
                payload["type"] = "all";
            } else if (this.exportSelection == "1") {
                // Current Page
                var ids = this.$refs.vuetable.tableData.map(({ id }) => id);
                payload["type"] = "current_page";
                if (ids == 0) {
                    this.errors.push("No Record(s)");
                    return;
                } else {
                    payload["ids"] = ids;
                }
            } else if (this.exportSelection == "2") {
                // Selected
                payload["type"] = "selected";
                if (this.checkedItems == 0) {
                    this.errors.push("No Selected Record(s)");
                    return;
                } else {
                    payload["ids"] = this.checkedItems;
                }
            } else {
                // Filtered
                payload["type"] = "filtered";
                additional_parameters = this.parameters;
            }

            var exportFields = this.fields;
            var cbIndex = this.fields.indexOf("__checkbox");
            if (cbIndex > -1) exportFields.splice(cbIndex, 1);
            var actionIndex = this.fields.indexOf("__slot:actions");
            if (actionIndex > -1) exportFields.splice(actionIndex, 1);

            payload["fields"] = exportFields;
            additional_parameters = additional_parameters.replace("?", "&");

            axios({
                url: baseUrl + additional_parameters,
                method: "POST",
                responseType: "blob", // important
                headers: {
                    Authorization: "Bearer " + secureStorage.getItem("accessToken"),
                    "Access-Control-Allow-Origin": "*", 'Request-Source': "BXI-File"
                },
                data: payload,
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "file.csv");
                document.body.appendChild(link);
                link.click();
                this.onClose();
                this.filterStatus = null;
                this.successMessage = "Download successful";
            });
        },
        displayMessage(message) {
            if (message["error"] != undefined) {
                this.onClose();
                this.errorMessage = message["error"];
                this.successMessage = null;
            }
        },
        removeMessage(type) {
            if (type == "error") this.errorMessage = null;
            else this.successMessage = null;
        },
        updateTableList() {
            var reference_array = this.availableFields;
            var array = this.checkedFields;
            if (array.length) {
                array.sort(function (a, b) {
                    return reference_array.indexOf(a) - reference_array.indexOf(b);
                });
                this.checkedFields = array;
            } else {
                this.checkedFields = ["id", "code", "name", "status"];
                this.$notification['warning']({
                    message: 'Customized columns cannot be empty',
                    description: 'Columns reset to default.'
                })
            }

            let localStoreName = this.currentProfile + "SupercardProfileCheckedFields";
            localStorage.setItem(localStoreName, JSON.stringify(this.checkedFields));

            this.fields = this.checkedFields.map(column => {
                if (column === "status") {
                    return {
                        name: "status",
                        callback: (value) => formatStatus(value)
                    }
                } else {
                    return {
                        name: column,
                        title: column.replace(/_/g, " ")
                    }
                }
            })
            this.fields.push("__slot:actions");
            this.fields.unshift("__checkbox")

            this.reinitializeFields();
            this.onClose();
        }
    },
    beforeMount: async function () {
        let localStoreName = this.currentProfile + "SupercardProfileCheckedFields"
        const SupercardProfileCheckedFields = localStorage.getItem(localStoreName)
        if (SupercardProfileCheckedFields != undefined && SupercardProfileCheckedFields != null && SupercardProfileCheckedFields != "[]") {
            this.checkedFields = JSON.parse(SupercardProfileCheckedFields)
            // this.fields = JSON.parse(SupercardProfileCheckedFields)
            // this.fields.unshift("id")
            // this.fields.unshift("__checkbox")
            this.fields = this.checkedFields.map(column => {
                if (column === "status") {
                    return {
                        name: "status",
                        callback: (value) => formatStatus(value)
                    }
                } else {
                    return {
                        name: column,
                        title: column.replace(/_/g, " ")
                    }
                }
            })
            this.fields.push("__slot:actions")
            this.fields.unshift("__checkbox")
            this.initLoad++
        } else {
            this.checkedFields = ["id", "code", "name", "status"];
            this.fields = [
                "__checkbox",
                { name: "id", title: "id" },
                { name: "code", title: "code" },
                { name: "name", title: "name" },
                {
                    name: "status",
                    callback: (value) => formatStatus(value)
                },
                "__slot:actions"
            ];
        
            localStorage.removeItem(localStoreName)
        }
    },
    mounted: async function () {
        //this.accessRights = ['A', 'W', 'V']
        const profileName = this.currentProfile.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
        var response = await HTTPRequest.getRequest(
          this.endPoint +
          "system_modules/get_system_module_by_name" +
          `?name=${profileName}`,
          null
        );
        if (response) {
            this.profileSubLabel = response.description
        }

        this.loading = true;
        component_x = this;
        this.accessRights = this.$attrs.accessRights;
        this.apiURL = this.currentApiURL;

        this.loading = false;
    },
};
</script>

<style>
.draggable {
    cursor: grab
}
</style>

<style scoped>
.sub-label {
    font-size: 12px;
    white-space: nowrap;
}
</style>